module.exports = __webpack_public_path__ + "static/media/blog-img.638909b3.webp";